// React
import React, { useMemo } from "react";

// Libraries
import PropTypes from "prop-types";
import { get, isArray, map } from "lodash";
import { Icon } from "semantic-ui-react";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const parseContactUri = (uri) => {
	if (!uri) return [];

	try {
		const data = typeof uri === "string" ? JSON.parse(uri) : uri;
		if (isArray(data)) return data;
		return data ? [data] : [];
	} catch {
		return [];
	}
};

const getContactName = (contact) => {
	return (
		get(contact, "name.formatted_name", "") ||
		get(contact, "name.first_name", "") ||
		[get(contact, "name.first_name", ""), get(contact, "name.last_name", "")].filter(Boolean).join(" ")
	);
};

const ContactContent = ({ item }) => {
	const contacts = useMemo(() => {
		return parseContactUri(item?.uri);
	}, [item?.uri]);

	if (!contacts.length) return null;

	return (
		<div className={styles.container}>
			{map(contacts, (contact, contactIndex) => {
				const name = getContactName(contact);
				const phones = get(contact, "phones", []);
				const phoneLabel = phones.length > 1 ? "Teléfonos" : "Teléfono";

				return (
					<div key={contactIndex} className={styles.card}>
						<div className={styles.header}>
							<Icon name="address card outline" className={styles.icon} />
							<Text className={styles.title}>Contacto</Text>
						</div>
						{name && (
							<div className={styles.field}>
								<Text className={styles.label}>Nombre</Text>
								<Text className={styles.value}>{name}</Text>
							</div>
						)}
						{phones.length > 0 && (
							<div className={styles.field}>
								<Text className={styles.label}>{phoneLabel}</Text>
								<div className={styles.phones}>
									{map(phones, (phoneEntry, phoneIndex) => {
										return (
											<Text key={phoneIndex} className={styles.value}>
												{get(phoneEntry, "phone", "")}
											</Text>
										);
									})}
								</div>
							</div>
						)}
					</div>
				);
			})}
		</div>
	);
};

ContactContent.propTypes = {
	item: PropTypes.object,
};

export default ContactContent;
